// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3iiOj","container":"styles_container__1IYwV","title":"styles_title__2mbvl","wrapper":"styles_wrapper__13cwH","answer":"styles_answer__3vhxM"};